import React from 'react';

export const IconHeart = ({
  size = 10,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00001 9.2L4.37481 8.6372C3.54161 7.8956 2.85421 7.2602 2.31261 6.731C1.77101 6.2018 1.34381 5.731 1.03101 5.3186C0.718612 4.9062 0.502012 4.5292 0.381212 4.1876C0.260412 3.846 0.200012 3.496 0.200012 3.1376C0.200012 2.396 0.454212 1.771 0.962612 1.2626C1.47101 0.7542 2.09601 0.5 2.83761 0.5C3.24601 0.5 3.64181 0.5876 4.02501 0.7628C4.40821 0.9376 4.73321 1.1834 5.00001 1.5002C5.26681 1.1834 5.59181 0.9376 5.97501 0.7628C6.35821 0.5876 6.75401 0.5 7.16241 0.5C7.90401 0.5 8.52901 0.7542 9.03741 1.2626C9.54581 1.771 9.80001 2.396 9.80001 3.1376C9.80001 3.496 9.74161 3.8418 9.62481 4.175C9.50841 4.5082 9.29381 4.879 8.98101 5.2874C8.66861 5.6958 8.23961 6.1688 7.69401 6.7064C7.14801 7.244 6.45001 7.896 5.60001 8.6624L5.00001 9.2Z"
        fill="currentColor"
      />
    </svg>
  );
};
